import { jwtDecode } from 'jwt-decode'
import { v4 } from 'uuid'
import { Message, PlugIntelligenceClient } from '../../clients/PlugIntelligenceClient'
import { logger } from '../../logger'

export interface MessageWithStream extends Message {
  id: string
  stream?: any
  doneStreaming?: boolean
}

export const authenticate = async (
  existingAuth: string | null,
  principalId: string
): Promise<string | null> => {
  if (existingAuth) {
    const decoded = jwtDecode(existingAuth)
    const expiresIn = decoded.exp! * 1000 - new Date().getTime()

    if (expiresIn > 60_000) {
      return existingAuth
    }
  }

  try {
    return await PlugIntelligenceClient.authenticate(principalId)
  } catch (e) {
    try {
      return await PlugIntelligenceClient.authenticate(principalId)
    } catch (e2) {
      logger.error('Failed to authenticate LLM chat session', {
        originalError: e2,
      })

      return null
    }
  }
}

export const getInitialMessage = () => {
  return {
    id: v4(),
    role: 'assistant' as MessageWithStream['role'],
    content: '',
    stream: {
      body: (async function* () {
        const content = await PlugIntelligenceClient.getInitialMessage()
        const tokens = content.match(/(.|[\r\n]){1,4}/g)!

        for (let i = 0; i < tokens.length; i++) {
          await new Promise((resolve) => setTimeout(resolve, 45))
          yield tokens[i]
        }
      })(),
    },
  }
}
